<template>
    <div>
        <section class="quiz-content-main">
            <div class="row">
                <div class="col-md-2" id="side-bar-main">
                    <div class="w3-sidebar w3-bar-block w3-light-grey w3-card stepsList">
                        <h5 class="quiz-heading pl10">Steps To Create Quiz</h5>
                        <button class="w3-bar-item w3-button steps-btn tablink btn-primary active" value="#step-1">Group
                        </button>
                        <button class="w3-bar-item w3-button steps-btn tablink" value="#step-5" disabled="disabled">
                            Questions
                        </button>
                    </div>
                </div>
                <div class="col-md-8" id="integration-main">
                    <div id="form-data">
                        <div class="row setup-content" id="step-1">
                            <div id="Group" class="w3-container steps">
                                <div class="quiz-c-tab current">
                                    <div class="row">
                                        <div class="col-md-7">
                                            <h2 class="quiz-heading">Create New {{data.name}} or Choose One Below</h2>
                                            <div class="quiz-top">
                                                <input type="text" maxlength="50"
                                                       :placeholder="'Add ' + data.name + ' Name'" class="topic-input"
                                                       id="groupInput" :data-level="data.level_enc_id"
                                                       :data-parent="data.parent_enc_id"/>
                                                <button type="button" id="grpinputbtn"><i class="fa fa-share"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <h2 class="quiz-heading">Select {{data.name}}</h2>
                                    <div class="row" id="group-row" v-if="data.name">
                                        <div class="col-md-3" v-for="cat in data.mockLabels" v-if="data.mockLabels.length != 0">
                                            <label class="radioLabel" @change="displayValue(cat.level_enc_id)">
                                                <input type="radio" :name="cat.level_enc_id" :txtvalue="cat.name"
                                                       :value="cat.label_enc_id" class="customRadio">
                                                <div class="quiz-group-box">
                                                    <p class="quiz-class">{{cat.name}}</p>
                                                </div>
                                            </label>
                                        </div>
                                        <div class="col-md-8 col-md-offset-2" v-if="data.mockLabels.length == 0">
                                            <h3>
                                                Please add sub topic or create questions.
                                            </h3>
                                        </div>
                                    </div>
<!--                                    <div class="row" v-else>-->
<!--                                        <div class="col-md-8 col-md-offset-2">-->
<!--                                            <h3>-->
<!--                                                Please add sub topic or create questions.-->
<!--                                            </h3>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                                <div class="step-next-btn hidden">
                                    <button class="btn btn-primary btn-md nextBtn pull-right" type="button">Next
                                    </button>
                                </div>
                                <!--&lt;!&ndash;                                    <div class="step-next-prev">&ndash;&gt;-->
                                <!--&lt;!&ndash;                                        <button class="btn btn-primary btn-md prevBtn" type="button">Back</button>&ndash;&gt;-->
                                <!--&lt;!&ndash;                                    </div>&ndash;&gt;-->
                                <!--                                </div>-->
                                <!--                                    </div>-->
                            </div>
                        </div>
                        <div class="row setup-content" id="step-5">
                            <div id="Questions" class="w3-container steps">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h2 class="quiz-heading">Enter Questions And Choose Correct Answer</h2>
                                        <div class="quiz-ques">
                                            <div class="quiz-textarea">
                                        <textarea placeholder="Enter Question" id="input_question"
                                                  class="ques-input"></textarea>
                                            </div>
                                            <div class="optionList">
                                                <div class="dis-flex">
                                            <textarea placeholder="Enter Option" id="input_answer1"
                                                      class="ques-input max300"></textarea>
                                                    <label class="checkbox-container correctAns">
                                                        <input type="radio" name="answer" class="ca-ans">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <p class="ca-message"></p>
                                                </div>
                                                <div class="dis-flex">
                                            <textarea placeholder="Enter Option" id="input_answer2"
                                                      class="ques-input max300"></textarea>
                                                    <label class="checkbox-container correctAns">
                                                        <input type="radio" name="answer" class="ca-ans">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <p class="ca-message"></p>
                                                </div>
                                                <div class="dis-flex">
                                            <textarea placeholder="Enter Option" id="input_answer3"
                                                      class="ques-input max300"></textarea>
                                                    <label class="checkbox-container correctAns" value="">
                                                        <input type="radio" name="answer" class="ca-ans">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <p class="ca-message"></p>
                                                    <button type="button" class="deleteBtn" data-toggle="tooltop"
                                                            title="Delete Option"
                                                            data-placement="top" @click="this.parentElement.remove()">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </div>
                                                <div class="dis-flex">
                                            <textarea placeholder="Enter Option" id="input_answer4"
                                                      class="ques-input max300"></textarea>
                                                    <label class="checkbox-container correctAns">
                                                        <input type="radio" name="answer" class="ca-ans">
                                                        <span class="checkmark"></span>
                                                    </label>
                                                    <p class="ca-message"></p>
                                                    <button type="button" class="deleteBtn" data-toggle="tooltop"
                                                            title="Delete Option"
                                                            data-placement="top" @click="this.parentElement.remove()">
                                                        <i class="fa fa-times"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="dis-flex flex-end">
                                                <button type="button" id="create_question">Create Question</button>
                                                <button type="button" id="add_options_btn">Add More Options</button>
                                            </div>
                                            <div class="quiz-button-flex">

                                                <button type="button" id="finish_quiz" @click="completeQuiz()">Complete Quiz</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <h2 class="quiz-heading">Questions Created</h2>
                                        <div class="question_created_zone"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="loading-list">
                        <div class="loading-list"></div>
                        <div class="loading-list-ring"></div>
                    </div>
                </div>
                <div class="col-md-2 pos" id="side-bar-2">
                    <div class="steps">
                        <ul class="step" id="stepsBar">
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <div class="CreateQuesButton">
            <button id="questions-btn" class="cqbBtn hidden" @click="showQuestionsTab()">Start Creating Questions</button>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios'
    import toastr from "../../../public/js/toastr";
    import {hideLoader, requestHeaders, showLoader} from "../../_helpers/apiHelper";

    export default {
        data: function () {
            return {
                currentTab: 0,
                courses: [],
                purposeError: '',
                valid: false,
                grp_names: [],
                subject_names: [],
                topics: [],
                question_list: [],
                question_data: {},
                sequence: 1,
                type: 1,
                label_enc_id: "",
                label_name: "",
                quiz_pool_enc_id: "",
                data: [],
                isValid: false,
            }
        },
        methods: {
            displayValue(name) {
                var t = this;
                var ele = document.getElementsByName(name);
                for (let i = 0; i < ele.length; i++) {
                    if (ele[i].checked) {
                        t.label_enc_id = ele[i].value;
                        var fieldName = ele[i].parentElement.querySelectorAll('p , li')[0].innerText;
                        t.label_name = fieldName;
                        let stepsBar = document.getElementById("stepsBar");
                        let div = document.createElement('li');
                        div.setAttribute('id', name);
                        div.setAttribute('class', 'stepsLi')
                        div.innerHTML = '<i class="fas fa-level-down-alt"></i>' + fieldName;
                        let fname = document.getElementById(name);
                        if (fname) {
                            fname.innerHTML = '<i class="fas fa-level-down-alt"></i>' + fieldName;
                        } else {
                            stepsBar.appendChild(div);
                        }
                        t.isValid = true;
                        t.showStepmarking();
                        t.getLevels();
                        document.getElementById('questions-btn').classList.remove('hidden');
                        setTimeout(function () {
                            ele[i].checked = false;
                        }, 500)
                    }
                }
                // setTimeout(function () {
                //     var steps = document.getElementsByClassName('quiz-c-tab');
                //     var setActive = false;
                //     for (let f = 0; f < steps.length; f++) {
                //         if (setActive){
                //             steps[f].classList.add('current');
                //             setActive = false;
                //             return false;
                //         }
                //         if(steps[f].classList.contains('current')){
                //             if(f === steps.length - 1){
                //                 var stepsMain = document.getElementsByClassName('setup-content');
                //                 for (let g = 0; g < stepsMain.length; g++) {
                //                     if (window.getComputedStyle(stepsMain[g]).display === "block") {
                //                         console.log(stepsMain[g].querySelectorAll('.nextBtn'));
                //                         stepsMain[g].querySelectorAll('.nextBtn')[0].click();
                //                         console.log('click');
                //                         return false;
                //                     }
                //                 }
                //             } else {
                //                 steps[f].classList.remove('current');
                //                 setActive = true;
                //             }
                //         }
                //     }
                // }, 500);
            },
            showQuestionsTab() {
                var stepsMain = document.getElementsByClassName('setup-content');
                for (let g = 0; g < stepsMain.length; g++) {
                    if (window.getComputedStyle(stepsMain[g]).display === "block") {
                        console.log(stepsMain[g].querySelectorAll('.nextBtn'));
                        stepsMain[g].querySelectorAll('.nextBtn')[0].click();
                        document.getElementById('questions-btn').classList.add('hidden');
                        return false;
                    }
                }
            },
            quesOptions() {
                let optionRadio = document.getElementsByClassName('ca-ans');
                for (let i = 0; i < optionRadio.length; i++) {
                    optionRadio[i].addEventListener('click', function () {
                        let correctAnswer = document.querySelectorAll(".correctAnswer");
                        if (correctAnswer.length == 1) {
                            correctAnswer[0].classList.remove('correctAnswer');
                            let sParent = correctAnswer[0].parentElement;
                            sParent.querySelector('.ca-message').innerHTML = "";
                            sParent.querySelector('.ca-message').classList.remove('ca-message-add');
                        }
                        let checkRadio = document.querySelector('input[name="answer"]:checked');
                        let parentlabel = checkRadio.parentElement;
                        let rootParent = parentlabel.parentElement;
                        let correctInput = rootParent.querySelector('.ques-input');
                        let correctMessage = rootParent.querySelector('.ca-message');
                        correctInput.classList.add('correctAnswer');
                        correctMessage.innerHTML = "Correct Answer";
                        correctMessage.classList.add('ca-message-add');
                    })
                }
            },
            showStepmarking() {
                let stepsLi = document.getElementsByClassName('stepsLi');
                let lastElm = stepsLi[stepsLi.length - 1];
                console.log(lastElm.querySelector('i'));
                let dc = document.getElementsByClassName('dc');
                if (dc.length > 0) {
                    for (let i = 0; i < dc.length; i++) {
                        dc[i].classList.remove('dc');
                    }
                }
                lastElm.querySelector('i').classList.add('dc');
            },
            creteGroup() {
                var t = this;
                let newGroupName = document.getElementById('groupInput').value;
                let parent_id = document.getElementById('groupInput').getAttribute('data-parent');
                let level_id = document.getElementById('groupInput').getAttribute('data-level');
                var comparetxt = $.trim(newGroupName).toLowerCase();
                if (comparetxt !== '') {
                    $('#group-row').find('input').each(function (index) {
                        t.grp_names.push($.trim($(this).attr('txtValue')).toLowerCase());
                    });
                    if (t.grp_names.includes(comparetxt) === false) {
                        const groupRow = document.getElementById('group-row');
                        let newDiv = document.createElement('div');
                        let elem_c = Math.floor((Math.random() * 1000) + 1);
                        newDiv.setAttribute('class', 'col-md-3 dynamic-label');
                        let last_input = '<input type="radio" name="' + level_id + '" id="gp' + elem_c + '" txtValue="' + newGroupName + '" value="small" class="customRadio" checked>';
                        newDiv.innerHTML = '<label class="radioLabel">' + last_input + '<div class="quiz-group-box"><p class="quiz-class">' + newGroupName + '</p></div></label>'
                        groupRow.insertBefore(newDiv, groupRow.firstChild);
                        document.getElementById('groupInput').value = "";
                        document.getElementById("groupInput").style.border = "none";
                        var ele = document.getElementsByName(level_id);
                        for (let i = 0; i < ele.length; i++) {
                            if (ele[i].checked) {
                                t.label_enc_id = ele[i].value;
                                var fieldName = ele[i].parentElement.querySelectorAll('p , li')[0].innerText;
                                t.label_name = fieldName;
                                let stepsBar = document.getElementById("stepsBar");
                                let div = document.createElement('li');
                                div.setAttribute('id', level_id);
                                div.setAttribute('class', 'stepsLi')
                                div.innerHTML = '<i class="fas fa-level-down-alt"></i>' + fieldName;
                                let fname = document.getElementById(level_id);
                                if (fname) {
                                    fname.innerHTML = '<i class="fas fa-level-down-alt"></i>' + fieldName;
                                } else {
                                    stepsBar.appendChild(div);
                                }
                                t.showStepmarking();
                                t.getLevels();
                            }
                        }
                        t.ajax_run(newGroupName, parent_id, level_id, $("#gp" + elem_c));
                    } else {
                        document.getElementById("groupInput").style.border = "1px solid red";
                    }
                } else {
                    document.getElementById("groupInput").style.border = "1px solid red";
                }
            },
            creteSubject() {
                var t = this;
                let newGroupName = document.getElementById('subjectInput').value;
                var comparetxt = $.trim(newGroupName).toLowerCase();
                if (comparetxt !== '') {
                    $('#subject-row').find('input').each(function (index) {
                        t.subject_names.push($.trim($(this).attr('txtValue')).toLowerCase());
                    });
                    if (t.subject_names.includes(comparetxt) === false) {
                        const groupRow = document.getElementById('subject-row');
                        let newDiv = document.createElement('div');
                        let elem_c = Math.floor((Math.random() * 1000) + 1);
                        newDiv.setAttribute('class', 'col-md-3');
                        let last_input = '<input type="radio" name="subject" id="sb' + elem_c + '" txtValue="' + newGroupName + '" value="small" class="customRadio" checked>';
                        newDiv.innerHTML = '<label class="radioLabel">' + last_input + '<div class="quiz-group-box"><div class="quiz-class">' + newGroupName + '</div></div></label>'
                        groupRow.insertBefore(newDiv, groupRow.firstChild);
                        document.getElementById('subjectInput').value = "";
                        document.getElementById("subjectInput").style.border = "none";
                        t.ajax_run(newGroupName, '/account/quiz/add-subject', $("#sb" + elem_c));
                    } else {
                        document.getElementById("subjectInput").style.border = "1px solid red";
                    }
                } else {
                    document.getElementById("subjectInput").style.border = "1px solid red";
                }
            },
            creteTopic() {
                var t = this;
                if ($("#user_topics").length == 0) {
                    const newRow = document.getElementById('user_topic_divs');
                    let newUl = document.createElement('ul');
                    newUl.setAttribute('id', 'user_topics');
                    newRow.appendChild(newUl);
                }
                let newGroupName = document.getElementById('topicinput').value;
                var comparetxt = $.trim(newGroupName).toLowerCase();
                if (comparetxt !== '') {
                    $('#user_topics').find('input').each(function (index) {
                        t.topics.push($.trim($(this).attr('txtValue')).toLowerCase());
                    });
                    if (t.topics.includes(comparetxt) === false) {
                        const groupRow = document.getElementById('user_topics');
                        let newDiv = document.createElement('label');
                        newDiv.setAttribute('class', 'radio_topics');
                        let elem_c = Math.floor((Math.random() * 1000) + 1);
                        let last_input = '<input type="radio" name="topic" id="tp' + elem_c + '" txtvalue="' + newGroupName + '" value="small" class="customRadio_topic" checked>';
                        newDiv.innerHTML = last_input + '<li class="topicList">' + newGroupName + '</li>';
                        groupRow.insertBefore(newDiv, groupRow.firstChild);
                        document.getElementById('topicinput').value = "";
                        document.getElementById("topicinput").style.border = "none";
                        t.ajax_run(newGroupName, '/account/quiz/add-topic', $("#tp" + elem_c));
                    } else {
                        document.getElementById("topicinput").style.border = "1px solid red";
                    }
                } else {
                    document.getElementById("topicinput").style.border = "1px solid red";
                }
            },
            ajax_run(data, parent_enc_id, id, elem) {
                var t = this;
                showLoader();
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/quiz/add-labels`, {
                    level_enc_id: id,
                    label: data,
                    parent_enc_id: parent_enc_id
                }, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        console.log(response['data']['response']);
                        elem.attr('value', response['data']['response']['data'].label_enc_id);
                        t.label_enc_id = response['data']['response']['data'].label_enc_id;
                        t.getLevels();
                        hideLoader();
                    }
                });
            },
            create_question() {
                var t = this;
                var li_list = '';
                let q = $.trim($('#input_question').val());
                let optionList = document.querySelector('.optionList');
                let question_txts = optionList.getElementsByTagName('textarea');
                let correctAnswer = document.querySelectorAll(".correctAnswer");
                if (correctAnswer.length == 1) {
                    correctAnswer[0].classList.remove('correctAnswer');
                    let sParent = correctAnswer[0].parentElement;
                    sParent.querySelector('.ca-message').innerHTML = "";
                    sParent.querySelector('.ca-message').classList.remove('ca-message-add');
                }
                var options_list = [];
                $.each(question_txts, function (index, value) {
                    let opt = $.trim(this.value);
                    if (index <= 1) {
                        if (opt == '' || opt == null) {
                            // swal({
                            //     title: "",
                            //     text: "Pleas Fill Out Atleas Two Answers !!",
                            // });
                            alert("Please Fill Out Atleas Two Answers !!")
                            return false;
                        }
                    }
                    if (opt !== '') {
                        options_list.push(opt);
                    }
                })
                let rad_answer = $('input[name="answer"]:checked');
                let elem_no = Math.floor((Math.random() * 1000) + 1);
                if (q.length !== 0 && rad_answer.length !== 0) {
                    var obj = {
                        'q': q,
                        'options': options_list,
                        'ra': rad_answer.val(),
                        'elem': 'collapse' + elem_no
                    }
                    t.question_list.push(obj);
                    for (var i = 0; i < options_list.length; i++) {
                        li_list += '<li>' + options_list[i] + '</li>';
                    }
                    console.log(li_list);
                    document.body.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                    var ansElems = optionList.querySelectorAll('.dis-flex');
                    var arr = [];
                    for (var ans = 0; ans < ansElems.length; ans++) {
                        var obj = {}
                        obj['answer'] = ansElems[ans].getElementsByTagName('textarea')[0].value;
                        let correctEl = ansElems[ans].getElementsByTagName('input')[0];
                        if (correctEl.checked) {
                            obj['is_answer'] = 1;
                        } else {
                            obj['is_answer'] = 0;
                        }
                        arr.push(obj);
                    }
                    t.question_data['answers'] = arr;
                    t.question_data['question'] = q;
                    t.question_data['organization_enc_id'] = t.$store.getters.getUser['college_enc_id'];
                    t.question_data['label_enc_id'] = t.label_enc_id;
                    t.question_data['name'] = t.label_name;
                    t.question_data['quiz_pool_enc_id'] = t.quiz_pool_enc_id;
                    showLoader();
                    console.log(li_list,3);
                    var url = this.$store.getters.getDomain;
                    console.log(li_list,4);
                    axios.post(`${url}api/v2/quiz/add-question-pool`, t.question_data, {headers: requestHeaders()}).then(function (response) {
                        if (response['data']['response']['status'] == 200) {
                            t.quiz_pool_enc_id = response['data']['response']['data'].quiz_pool_enc_id;
                            console.log(li_list,5);
                            $('.question_created_zone').prepend('<div class="card"><div class="card-header" role="tab"><a data-toggle="collapse" data-parent="#accordion" href="#collapse' + elem_no + '" aria-expanded="false" aria-controls="collapseOne" class="collapsed flex2"><div class="q1"><span>Q:</span>' + q + '</div></a><span class="btndelete" value="collapse' + elem_no + '" data-id="' + response['data']['response']['data'].question_enc_id + '"><i class="far fa-trash-alt"></i></span><span class="btnedit"><i class="fas fa-pencil-alt"></i></span> <a data-toggle="collapse" data-parent="#accordion" href="#collapse' + elem_no + '" aria-expanded="false" aria-controls="collapseOne" class="collapsed"><i class="fa fa-plus"></i></a></div><div id="collapse' + elem_no + '" class="collapse" role="tabpanel" aria-labelledby="quesThree" aria-expanded="false"><div class="card-block"><div class="q-ans"><ul>' + li_list + '</ul></div></div></div></div>');
                            toastr.success('One New Question Created', 'Success');
                            li_list = '';
                            t.clearQuestion();
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                        hideLoader();
                    });
                } else {
                    // swal({
                    //     title: "",
                    //     text: "Please Make sure all the Answers and Question are filled up correctly along With right Answer !!",
                    // });
                    alert('Please Make sure all the Answers and Question are filled up correctly along With right Answer !!');
                }
            },
            clearQuestion() {
                $('#input_question').val("");
                $('#input_answer1').val("");
                $('#input_answer2').val("");
                $('#input_answer3').val("");
                $('#input_answer4').val("");
                document.querySelector('input[name="answer"]:checked').checked = false;
            },
            removeByAttr(arr, attr, value) {
                var i = arr.length;
                while (i--) {
                    if (arr[i]
                        && arr[i].hasOwnProperty(attr)
                        && (arguments.length > 2 && arr[i][attr] === value)) {
                        arr.splice(i, 1);
                    }
                }
                return arr;
            },
            validate_tab_first(isValid, nextStepWizard) {
                if (this.isValid) {
                    nextStepWizard.removeAttr('disabled').trigger('click');
                } else {
                    alert("Please Select Or Create One Group !!");
                }
            },
            showMarking() {
                document.getElementById('marking-details').style.display = "block";
            },
            unshowMarking() {
                document.getElementById('marking-details').style.display = "none";
            },
            showPayment() {
                document.getElementById('final-details').style.display = "none";
                document.getElementById('payment-details').style.display = "block";
            },
            showSubmit() {
                document.getElementById('final-details').style.display = "block";
                document.getElementById('payment-details').style.display = "none";
            },
            submitForm(payment = false, amount = null, is_negetive = false, ngm = null) {
                var t = this;
                var formData = new FormData();
                formData.append('subject', $("input[name='subject']:checked").val());
                formData.append('topic', $("input[name='topic']:checked").val());
                formData.append('group', $("input[name='group']:checked").val());
                formData.append('intro', $("#inro_input").val());
                formData.append('questions', JSON.stringify(t.question_list));
                formData.append('t_marks', $("#input_m").val());
                formData.append('time_dur', $("#input_t").val());
                formData.append('correct_marks', $("#input_cam").val());
                if (payment) {
                    formData.append('payment_status', 1);
                    formData.append('amount', amount);
                } else {
                    formData.append('payment_status', 0);
                }

                if (is_negetive) {
                    formData.append('negetive_marks', ngm);
                }
                $.ajax({
                    url: '/account/quiz/submit-form',
                    dataType: 'text',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: formData,
                    type: 'post',
                    beforeSend: function () {
                        $('#sbt_btn_p').css('display', 'none');
                        $('#sbt_btn_wp').css('display', 'none');
                        $('.buttonload').css('display', 'block');
                    },
                    success: function (res) {
                        var res = JSON.parse(res);
                        $('#sbt_btn_p').css('display', 'block');
                        $('#sbt_btn_wp').css('display', 'block');
                        $('.buttonload').css('display', 'none');
                        if (res.status == false) {
                            toastr.error(res.response, 'Failed');
                        } else if (res.status == true) {
                            swal({
                                    title: "Submitted!",
                                    text: "Your Quiz Has Been Created ! Click on Below Link To Share And Play",
                                    type: "success",
                                    showCancelButton: false,
                                    confirmButtonClass: "btn-primary",
                                    confirmButtonText: "View Quiz",
                                    closeOnConfirm: false,
                                    closeOnCancel: false
                                },
                                function (isConfirm) {
                                    if (isConfirm) {
                                        window.location.pathname = "/quiz/" + res.slug;
                                    }
                                });
                        }
                    }
                })
            },
            fillupall() {
                var t = this;
                let sbj = $.trim($("input[name='subject']:checked").attr("txtvalue"));
                let tpc = $.trim($("input[name='topic']:checked").attr("txtvalue"));
                let grp = $.trim($("input[name='group']:checked").attr("txtvalue"));
                let intro_txt = $.trim($("#inro_input").val());
                let question_count = t.question_list.length;
                $('#quiz_question_topic').html(tpc);
                $('#quiz_question_group').html(grp);
                $('#quiz_question_subject').html(sbj);
                $('#quiz_question_intro').html(intro_txt);
                $('#quiz_question_counts').html(question_count);
            },
            addOption() {
                let optionList = document.querySelector('.optionList');
                let count_elem = optionList.getElementsByTagName('textarea').length;
                if (count_elem <= 5) {
                    let newOption = document.createElement('div');
                    let elem_c = Math.floor((Math.random() * 1000) + 1);
                    newOption.setAttribute('class', 'dis-flex');
                    newOption.innerHTML = '<textarea placeholder="Enter Option" id="input' + elem_c + '" class="ques-input max300"></textarea>\n' +
                        '    <label class="checkbox-container correctAns">\n' +
                        '        <input type="radio" name="answer" class="ca-ans">\n' +
                        '        <span class="checkmark"></span>\n' +
                        '    </label>\n' +
                        '    <p class="ca-message"></p>\n' +
                        '    <button type="button" class="deleteBtn" onclick="this.parentElement.remove()"><i class="fa fa-times"></i></button>';

                    optionList.appendChild(newOption);
                } else {
                    // swal({
                    //     title: "",
                    //     text: "You Can Have Maximum 6 Options Only !!",
                    // });
                    alert("You Can Have Maximum 6 Options Only !!");
                }
            },
            getLevels() {
                var t = this;
                showLoader();
                var url = this.$store.getters.getDomain;

                axios.post(`${url}api/v2/quiz/levels`, {
                    type: t.type,
                    sequence: t.sequence,
                    parent_enc_id: t.label_enc_id
                }, {headers: requestHeaders()}).then(function (response) {
                    if (response['data']['response']['status'] == 200) {
                        t.data = response['data']['response']['data'];
                        t.sequence = t.sequence + 1;
                        var alreadyElem = document.getElementsByClassName('dynamic-label');
                        for(var w = 0;w<alreadyElem.length;w++){
                            alreadyElem[w].remove();
                        }
                    }
                    hideLoader();
                });
            },
            completeQuiz(){
                var t = this;
                var r = confirm("Are you sure you want to leave this page, make sure all questions are added!");
                if (r == true) {
                    t.$router.push({path: '/dashboard'})
                } else {
                    return false;
                }
            },
        },
        mounted() {
            var t = this;
            t.quesOptions();
            t.getLevels();
            $(document).on('click', '#grpinputbtn', function (e) {
                e.preventDefault();
                t.creteGroup();
            })
            $('#groupInput').keypress(function (event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    t.creteGroup();
                }
            });

            $(document).on('click', '#finish_quiz', function (e) {
                e.preventDefault();
                alert('Quiz Complete');
                return false
                if (t.question_list.length !== 0) {
                    document.querySelector('.payLink').style.display = "block";
                    var curStep = $(this).closest(".setup-content"),
                        curStepBtn = curStep.attr("id"),
                        nextStepWizard = $('.stepsList button[value="#' + curStepBtn + '"]').next();
                    t.fillupall();
                    nextStepWizard.removeAttr('disabled').trigger('click');
                } else {
                    // swal({
                    //     title: "",
                    //     text: "Please Create Atleast One Question !!",
                    // });
                    alert("Please Create Atleast One Question !!");
                }
            });
            $(document).on('click', '.payLink', function (e) {
                t.fillupall();
            })
            $(document).on('click', '#create_question', function (e) {
                e.preventDefault();
                t.create_question();
            });
            var navListItems = $('.steps-btn'),
                allWells = $('.setup-content'),
                allNextBtn = $('.nextBtn'),
                allPrevBtn = $('.prevBtn');

            allWells.hide();
            $('#step-1').show();
            navListItems.click(function (e) {
                e.preventDefault();
                var target = $($(this).attr('value')),
                    item = $(this);

                if (!item.hasClass('disabled')) {
                    navListItems.removeClass('btn-primary').addClass('btn-default');
                    item.addClass('btn-primary');
                    allWells.hide();
                    target.show();
                    target.find('input:eq(0)').focus();
                }
            });

            allNextBtn.click(function () {
                var curStep = $(this).closest(".setup-content"),
                    curStepBtn = curStep.attr("id"),
                    nextStepWizard = $('.stepsList button[value="#' + curStepBtn + '"]').next(),
                    isValid = false;
                    t.validate_tab_first(isValid, nextStepWizard);
            });
            allPrevBtn.click(function () {
                var prevStep = $(this).closest(".setup-content").prev("div"),
                    prevStepBtn = prevStep.attr("id"),
                    prevStepWizard = $('.stepsList button[value="#' + prevStepBtn + '"]');
                prevStepWizard.trigger('click');
            })
            $(document).on('click', '.btndelete', function (e) {
                e.preventDefault();
                if (confirm('Do You Want To Delete This Question ?')) {
                    showLoader();
                    let elem = $(this).attr('value');
                    let elemVal = $(this).attr('data-id');
                    t.removeByAttr(t.question_list, 'elem', elem);
                    $(this).parent().parent().remove();
                    var url = t.$store.getters.getDomain;

                    axios.post(`${url}api/v2/quiz/remove-question`, {question_enc_id: elemVal}, {headers: requestHeaders()}).then(function (response) {
                        if (response['data']['response']['status'] == 200) {
                            toastr.success('Question Deleted', 'Success');
                        }
                        hideLoader();
                    });
                }
            })
            $(document).on('change', 'input[name="choice_payment"]', function (e) {
                e.preventDefault();
                let v = $(this).val();
                if (v == 1) {
                    t.showPayment();
                } else {
                    t.showSubmit();
                }
            })

            $(document).on('change', 'input[name="choice_marks_system"]', function (e) {
                e.preventDefault();
                let v = $(this).val();
                if (v == 1) {
                    t.showMarking();
                } else {
                    t.unshowMarking();
                }
            })
            $(document).on('click', '#sbt_btn_p', function (e) {
                e.preventDefault();
                let newGroupName = document.getElementById('p_input').value;
                let input_m = document.getElementById('input_m').value;
                let input_t = document.getElementById('input_t').value;
                let input_cam = document.getElementById('input_cam').value;
                let pv = $("input[name='choice_marks_system']:checked").val();
                var comparetxt = $.trim(newGroupName).toLowerCase().replace(/,/g, '');
                var comparetxt1 = $.trim(input_m).toLowerCase().replace(/,/g, '');
                var comparetxt2 = $.trim(input_t).toLowerCase().replace(/,/g, '');
                var comparetxt3 = $.trim(input_cam).toLowerCase().replace(/,/g, '');
                if (comparetxt == '' || comparetxt <= 0) {
                    document.getElementById("p_input").style.border = "1px solid #ff0000";
                    document.getElementById("p_input").focus();
                    return false;
                } else {
                    document.getElementById("p_input").style.border = "1px solid #26c22bsubmit";
                }
                if (comparetxt1 == '' || comparetxt1 <= 0) {
                    document.getElementById("input_m").style.border = "1px solid #ff0000";
                    document.getElementById("input_m").focus();
                    return false;
                } else {
                    document.getElementById("input_m").style.border = "1px solid #26c22b";
                }
                if (comparetxt2 == '' || comparetxt2 <= 0) {
                    document.getElementById("input_t").style.border = "1px solid #ff0000";
                    document.getElementById("input_t").focus();
                    return false;
                } else {
                    document.getElementById("input_t").style.border = "1px solid #26c22b";
                }
                if (comparetxt3 == '' || comparetxt3 <= 0) {
                    document.getElementById("input_cam").style.border = "1px solid #ff0000";
                    document.getElementById("input_cam").focus();
                    return false;
                } else {
                    document.getElementById("input_cam").style.border = "1px solid #26c22b";
                }
                if (pv == 1) {
                    let ps = $.trim($('#penelty_score').val());
                    if (ps == '') {
                        document.getElementById("penelty_score").style.border = "1px solid #ff0000";
                        document.getElementById("penelty_score").focus();
                        return false;
                    } else {
                        ngm = ps;
                        is_negetive = true;
                        document.getElementById("penelty_score").style.border = "1px solid #26c22b";
                    }
                } else if (pv == 0) {
                    ngm = null;
                    is_negetive = false;
                } else {
                    // swal({
                    //     title: "",
                    //     text: "Please select Weather you allow negetive marking or not !!",
                    // });
                    alert("Please select Weather you allow negetive marking or not !!");
                    return false;
                }
                t.submitForm(payment = true, amount = comparetxt, is_negetive = is_negetive, ngm = ngm);
            })

            $(document).on('click', '#sbt_btn_wp', function (e) {
                e.preventDefault();
                let input_m = document.getElementById('input_m').value;
                let input_t = document.getElementById('input_t').value;
                let input_cam = document.getElementById('input_cam').value;
                let pv = $("input[name='choice_marks_system']:checked").val();
                var comparetxt1 = $.trim(input_m).toLowerCase().replace(/,/g, '');
                var comparetxt2 = $.trim(input_t).toLowerCase().replace(/,/g, '');
                var comparetxt3 = $.trim(input_cam).toLowerCase().replace(/,/g, '');
                if (comparetxt1 == '' || comparetxt1 <= 0) {
                    document.getElementById("input_m").style.border = "1px solid #ff0000";
                    document.getElementById("input_m").focus();
                    return false;
                } else {
                    document.getElementById("input_m").style.border = "1px solid #26c22b";
                }
                if (comparetxt2 == '' || comparetxt2 <= 0) {
                    document.getElementById("input_t").style.border = "1px solid #ff0000";
                    document.getElementById("input_t").focus();
                    return false;
                } else {
                    document.getElementById("input_t").style.border = "1px solid #26c22b";
                }
                if (comparetxt3 == '' || comparetxt3 <= 0) {
                    document.getElementById("input_cam").style.border = "1px solid #ff0000";
                    document.getElementById("input_cam").focus();
                    return false;
                } else {
                    document.getElementById("input_cam").style.border = "1px solid #26c22b";
                }
                if (pv == 1) {
                    let ps = $.trim($('#penelty_score').val());
                    if (ps == '') {
                        document.getElementById("penelty_score").style.border = "1px solid #ff0000";
                        document.getElementById("penelty_score").focus();
                        return false;
                    } else {
                        ngm = ps;
                        is_negetive = true;
                        document.getElementById("penelty_score").style.border = "1px solid #26c22b";
                    }
                } else if (pv == 0) {
                    ngm = null;
                    is_negetive = false;
                } else {
                    // swal({
                    //     title: "",
                    //     text: "Please select Weather you allow negetive marking or not !!",
                    // });
                    alert("Please select Weather you allow negetive marking or not !!");
                    return false;
                }
                t.submitForm(payment = false, ammount = null, is_negetive = is_negetive, ngm = ngm);
            });
            $(document).on('click', '#add_options_btn', function (e) {
                e.preventDefault();
                t.addOption();
                t.quesOptions();
            })
        },
    }
</script>

<style scoped>
    .quiz-content-main {
        padding: 0px 15px;
    }

    .padd15 {
        padding: 0 15px 0 0;
    }

    .flex-end {
        justify-content: space-between;
    }

    #side-bar-main,
    #integration-main,
    #side-bar-2 {
        height: calc(100vh - 100px);
    }

    .btn-primary {
        color: #fff !important;
        background-color: #00A0E3 !important;
        border-color: #00A0E3 !important;
    }

    #side-bar-2,
    #side-bar-main {
        background-color: #f8f8f8;
        padding: 10px 0 0 0;
    }

    #integration-main {
        padding-top: 00px;
        padding-bottom: 30px;
    }

    .page-container-bg-solid .page-content {
        margin-bottom: 0px;
    }

    .step {
        padding: 0 0px;
        text-align: left;
        list-style: none;
    }

    .step h3 {
        margin: 0 0 20px;
        font-family: roboto;
        text-transform: capitalize;
    }

    #marking-details {
        display: none;
    }

    .quiz-textarea textarea {
        height: 100px;
        resize: none;
    }

    .quiz-button-flex {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }

    #finish_quiz {
        width: 100%;
        max-width: 425px;
        background: #20B2AA;
    }

    #payment-details, #final-details {
        display: none;
    }

    .recom-charac {
        margin: 0;
        font-size: 12px;
    }

    .note-text {
        background: #F8F8F8;
        max-width: 400px;
        padding: 18px 0;
        font-size: 16px;
        font-family: lora;
        text-transform: capitalize;
    }

    .note-text span {
        background: #eee;
        padding: 20px;
        margin-right: 10px;
    }

    .pl10 {
        padding-left: 10px;
    }

    .quiz-heading {
        font-size: 20px;
        font-family: lora;
    }

    .dis-flex {
        display: flex;
    }

    .dis-flex textarea {
        height: 60px;
        resize: none;
    }

    .quiz-ques {
        display: flex;
        flex-direction: column;
    }

    .ques-input {
        width: 100%;
        border: 1px solid #eee;
        padding: 8px 10px;
        margin-bottom: 10px;
        overflow-wrap: break-word;
    }

    .max300 {
        max-width: 400px;
    }

    .quiz-ques button, .quiz-intro button, .pay-btns button {
        max-width: 200px;
        background: #00a0e3;
        color: #fff;
        border: none;
        padding: 10px 0;
    }

    .quiz-ques button {
        padding: 10px 15px;

    }

    #create_question {
        background: #ff7803;
    }

    .pay-btns button {
        margin-bottom: 10px;
    }

    .pay-btns {
        margin: 10px 0;
    }

    .pay-btns button {
        margin-right: 10px;

        padding: 10px 15px;
    }

    .quiz-intro button {
        padding: 10px 15px;
        float: right;
        margin-left: 10px;
    }

    .quiz-intro-textarea {
        height: 180px;
        width: 100%;
        padding: 8px 10px;
        border: 1px solid #eee;
        resize: none;
    }

    .previous-topics ul {
        list-style: none;
        padding: 0;
        border-top: 1px solid #eee;
    }

    .previous-topics ul li {
        padding: 8px 10px;
    }

    .previous-topics ul li:nth-child(even) {
        background: #f2f2f2
    }

    .quiz-top, .quiz-search {
        width: 100%;
        border: 1px solid #eee;
    }

    .quiz-top button, .quiz-search button {
        padding: 8px 14px;
        border: none;
        background: #00a0e3;
        color: #fff;
        float: right;
    }

    .quiz-top button i {
        transform: rotate(180deg);
    }

    .topic-input {
        width: 89%;
        padding: 8px 10px;
        border: transparent;
    }

    .quiz-class {
        font-size: 20px;
        font-family: lora;
    }

    .quiz-subject {
        font-size: 18px;
        font-family: lora;
    }

    .qc-heading {
        margin-top: 30px;
    }

    .copyright {
        display: none;
    }

    .container-fluid {
        padding-left: 0px;
        padding-right: 0px;
    }

    .page-content {
        padding: 0px 15px !important;
    }

    .position-rel {
        position: relative;
        max-width: 200px;
    }

    .w3-sidebar {
        position: sticky;
        overflow: auto;
        top: 100px;
    }

    .w3-light-grey, .w3-hover-light-grey:hover, .w3-light-gray, .w3-hover-light-gray:hover {
        color: #000 !important;
    }

    .w3-bar-block .w3-bar-item {
        width: 100%;
        padding: 8px 16px;
        text-align: left;
        border: none;
        white-space: normal;
        float: none;
        outline: 0;
    }

    .w3-btn, .w3-button {
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .w3-btn, .w3-button {
        padding: 8px 16px;
        vertical-align: middle;
        overflow: hidden;
        text-decoration: none;
        color: inherit;
        background-color: inherit;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;
    }

    .active {
        background: #00a0e3;
        color: #fff;
    }

    .w3-padding {
        padding: 8px 16px !important;
    }

    .w3-container, .w3-panel {
        padding: 0.01em 16px;
    }

    .checkbox-container {
        display: block;
        position: relative;
        margin: 0px;
        cursor: pointer;
        font-size: 22px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    /* Hide the browser's default checkbox */
    .checkbox-container input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    /* Create a custom checkbox */
    .checkmark {
        position: absolute;
        top: 0;
        left: 0;
        height: 25px;
        width: 25px;
        border: 1px solid #00a0e3;
    }

    /* On mouse-over, add a grey background color */

    /* When the checkbox is checked, add a blue background */
    .checkbox-container input:checked ~ .checkmark, .checkbox-container input:hover ~ .checkmark {
        background-color: #2196F3;
    }

    .checkmark:after {
        content: "";
        position: absolute;
        display: none;
    }

    .checkbox-container input:checked ~ .checkmark:after {
        display: block;
    }

    /* Style the checkmark/indicator */
    .checkbox-container .checkmark:after {
        left: 9px;
        top: 5px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 3px 3px 0;
        -webkit-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .correctAnswer {
        color: #00a0e3;
        border: 1px solid #00a0e3;
    }

    .topicList:hover {
        cursor: pointer;
    }

    .payment-text {
        font-family: lora;
        font-size: 18px;
    }

    .payLink {
        display: none;
    }

    .ca-message {
        margin: 0px 0 0 0px;
        position: absolute;
        bottom: -10px;
    }

    .ca-message-add {
        background: #00a0e3;
        color: #fff;
        padding: 1px 5px;
        font-size: 13px;
        font-weight: 600;
        border-radius: 0 0 5px 5px;

    }

    /*-------modal ----------*/
    .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        padding-top: 10px; /* Location of the box */
        left: 0;
        top: 100px;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: scroll; /* Enable scroll if needed */
        background-color: rgb(0, 0, 0); /* Fallback color */
        background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
    }

    /* Modal Content */
    .modal-content {
        background-color: #fefefe;
        margin: 5% auto;
        padding: 20px;
        border: 1px solid #888;
        width: 60%;
        text-align: center;

    }

    /* The Close Button */
    .close, .closeInfo {
        color: #aaaaaa;
        float: right;
        font-size: 28px;
        font-weight: bold;
        position: absolute;
        top: 10px;
        right: 10px
    }

    .close:hover,
    .closeInfo:hover,
    .close:focus,
    .closeInfo:focus {
        color: #000;
        text-decoration: none;
        cursor: pointer;
    }

    .stepwizard-step p {
        margin-top: 10px;
    }

    .stepwizard-row {
        display: table-row;
    }

    .stepwizard {
        display: table;
        width: 100%;
        position: relative;
    }

    .stepwizard-step button[disabled] {
        opacity: 1 !important;
        filter: alpha(opacity=100) !important;
    }

    .stepwizard-row:before {
        top: 14px;
        bottom: 0;
        position: absolute;
        content: " ";
        width: 100%;
        height: 1px;
        background-color: #ccc;
        z-order: 0;

    }

    .stepwizard-step {
        display: table-cell;
        text-align: center;
        position: relative;
    }

    .btn-circle {
        width: 30px;
        height: 30px;
        text-align: center;
        padding: 6px 0;
        font-size: 12px;
        line-height: 1.428571429;
        border-radius: 15px;
    }

    .step-next-btn {
        margin-top: 40px;
    }

    .steps-btn {
        float: left !important;
        text-decoration: none;
    }

    button[disabled] {
        opacity: 1 !important;
        filter: alpha(opacity=100) !important;
    }

    .btn-shape {
        border-radius: 21px !important;
        min-height: 20px !important;
    }

    .buttonload {
        background-color: #4CAF50; /* Green background */
        border: none; /* Remove borders */
        color: white; /* White text */
        padding: 12px 16px; /* Some padding */
        font-size: 16px /* Set a font size */
    }

    .buttonload {
        display: none;
    }

    .quiz-title {
        background: #f8f8f8;
        color: #000;
        padding: 10px 15px;
        font-size: 18px;
        font-family: lora;
        display: flex;
        align-items: center;
    }

    .mt20 {
        margin-top: 20px;
    }

    .quiz-title {
        background: #f8f8f8;
        color: #000;
        padding: 10px 15px;
        font-size: 18px;
        font-family: lora;
        display: flex;
        align-items: center;
    }

    .quiz-details p span, .quiz-info p span {
        font-weight: bold;
    }

    #Rules {
        margin: 40px 0 0 0;
    }

    .qModal h4 {
        font-weight: bold;
        color: #333;
        font-family: roboto;
        font-size: 20px;
    }

    .qModal h2 {
        font-weight: bold;
        color: #00a0e3;
        font-family: lora;
        font-size: 30px;
    }

    .qModal p {
        color: #333;
        font-family: roboto;
        font-size: 16px;
    }

    .qshare {
        padding-inline-start: 0;
    }

    .qshare li {
        list-style: none;
        display: inline;
        padding: 10px 10px;
    }

    .qshare li a {
        font-size: 23px;
        color: #333;
    }

    .qshare li a:hover {
        color: #00a0e3;
    }

    .qm-logo {
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
    }

    .qm-name {
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .qm-logo img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
    }

    .font-weight-500 {
        font-weight: 500 !important;
    }

    .deleteBtn {
        padding: 1px 6px !important;
        color: #333 !important;
        font-size: 17px;
        background: transparent !important;
        margin-top: 10px;
    }

    .deleteBtn:hover {
        color: #00a0e3 !important;
    }

    .dis-flex {
        display: flex;
        position: relative;
        margin: 0px 0 16px 0;
        max-width: 425px;
    }

    .dis-flex textarea {
        height: 60px;
        resize: none;
    }

    .quiz-c-tab {
        display: none;
    }

    .quiz-c-tab.current {
        display: block;
    }

    .cqbBtn {
        background: #00a0e3;
        color: #fff;
        padding: 10px 20px 7px;
        border: none;
        border-radius: 10px 10px 0 0;
        font-size: 16px;
    }

    .cqbBtn:hover {
        box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    }

    .CreateQuesButton {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
    }
    .loading-list{top:0;}
</style>